import SectionPage from '../components/SectionPage';

export default function Contacto() {
  return (
    <SectionPage
      title="Contacto"
      intro="Hablemos sobre reciclaje, trazabilidad y sustentabilidad."
      sections={[
        {
          title: 'Datos',
          id: 'datos',
          body: (
            <div>
              <p><strong>info@recycla.cl</strong></p>
              <p><strong>+56 2 2949 3040</strong></p>
              <p>Volcán Lascar Poniente 761, Barrio Industrial Lo Boza, Pudahuel.</p>
            </div>
          ),
        },
      ]}
    />
  );
}
